module.exports = __webpack_public_path__ + "img/2or5.db90207c.jpg";